import { DefaultService } from '@/services/DefaultService';

export default class TipoEnderecoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	updateSituacaoVendas(tipoEndereco) {
		return this._http.post(`${this._env}/vendas/tipoendereco/updatesituacao`, tipoEndereco, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
    }

    updateSituacaoAgro(tipoEndereco) {
		return this._http.post(`${this._env}/agro/tipoendereco/updatesituacao`, tipoEndereco, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
    }

	findAllVendas(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/tipoendereco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllAgro(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/tipoendereco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findAllCombo(...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/getcombo/tipoendereco.json?param=${params}`), this._headers).then(res => {
      return res.body;
		}, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
		});
	}

	findVendas(id) {
		return this._http.get(`${this._env}/vendas/tipoendereco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAgro(id) {
		return this._http.get(`${this._env}/agro/tipoendereco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

	saveVendas(form) {
		return this._http.post(`${this._env}/vendas/tipoendereco`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(form) {
		return this._http.post(`${this._env}/agro/tipoendereco`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}